import {
  faPaperPlane,
  faEye,
  faCalendarCheck,
  faHourglassEnd,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import OptionsCheckboxFilter, {
  OptionItem,
} from "../options-checkbox-filter/OptionsCheckboxFilter";
import { BaseFilterProps } from "interfaces/filter-component-base";
import "./StatusFilter.scss";
const statusOptions: OptionItem[] = [
  {
    label: "Sent",
    value: "sent",
    description: "Invitation sent",
    icon: faPaperPlane,
    iconClassName: "sent",
  },
  {
    label: "Viewed",
    value: "viewed",
    description: "Creator viewed",
    icon: faEye,
    iconClassName: "viewed",
  },
  {
    label: "Booked",
    value: "booked",
    description: "Booking confirmed",
    icon: faCalendarCheck,
    iconClassName: "booked",
  },
  {
    label: "Expired",
    value: "expired",
    description: "Invite expired",
    icon: faHourglassEnd,
    iconClassName: "expired",
  },
  {
    label: "Rejected",
    value: "rejected",
    description: "Creator rejected",
    icon: faBan,
    iconClassName: "rejected",
  },
];
const StatusFilter = (props: BaseFilterProps) => {
  return <OptionsCheckboxFilter {...props} options={statusOptions} />;
};
export default StatusFilter;
